angular.module('MktzapApp.Directives')
  .factory('UtilsService', service)
  service.$inject = ['$filter', '$rootScope']
   function service ($filter, $rootScope) {
    return {
      isJsonString: isJsonString,
      jsonParseText: jsonParseText,
      hasAllowPhoneMask
    };

    function isJsonString (text) {
      if (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@')
        .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
        .replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
        return true;
      } else {
        return false;
      }
    }

    function jsonParseText (text) {
      if (isJsonString(text)) {
        return JSON.parse(text);
      } else {
        return text;
      }
    }

    function hasAllowPhoneMask (input) {
      if ($rootScope.company_metadata.allow && $rootScope.company_metadata['phone_mask'] && $rootScope.company_metadata['phone_mask'].branch == true) {
        if ($rootScope.checkMenuAccess('attendances.actions.allowPhoneMask') && !$rootScope.checkMenuAccess('lord')) {
          if (
            ($rootScope.company_metadata['phone_mask'].user_operator && $rootScope.profiles.ROLE_OPERATOR == $rootScope.user_data.role) ||
            ($rootScope.company_metadata['phone_mask'].user_manager && $rootScope.profiles.ROLE_MANAGER == $rootScope.user_data.role) || 
            ($rootScope.company_metadata['phone_mask'].user_promoter && $rootScope.profiles.ROLE_PROMOTER == $rootScope.user_data.role) ||
            ($rootScope.company_metadata['phone_mask'].user_administrator && $rootScope.profiles.ROLE_MESSAGES_PORTAL_MANAGER == $rootScope.user_data.role) ||
            ($rootScope.company_metadata['phone_mask'].user_supervisor && $rootScope.profiles.ROLE_MESSAGES_PORTAL_SUPERVISOR == $rootScope.user_data.role)
          ) {
            return $filter("display_name_phone")(input);
          }
        }

        return input;
      }

      return input;
    }
  }
